import { style } from '@vtex/admin-ui'

export const indexerLogContainer = style({
  padding: '$space-6',
  width: '100%',
})

export const indexerLog = style({
  borderRadius: '$base',
  bg: 'var(--admin-ui-bg-secondary) !important',
  padding: '$space-6',
  whiteSpace: 'pre-wrap',
})

export const titleContainer = style({
  'div[data-direction="row"]': {
    'button[data-variant="neutralTertiary"]': {
      marginLeft: 'auto !important',
    },
  },
})
